module.exports = __webpack_public_path__ + "static/media/dev.2cde2882.jpg";